import { render, staticRenderFns } from "./DishBaseTableBodyRow.vue?vue&type=template&id=449528ef&"
import script from "./DishBaseTableBodyRow.vue?vue&type=script&lang=js&"
export * from "./DishBaseTableBodyRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports